angular.module('impactx.ownsecurityroles').controller('OwnSecurityRoleController', OwnSecurityRoleController);
OwnSecurityRoleController.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    'TranslationService',
    'ConfirmationService',
    '$routeParams',
    'ToolbarService',
    'themeFactory'
];

function OwnSecurityRoleController($scope, dataGen, BackService, ToastService, TranslationService, ConfirmationService, $routeParams, ToolbarService, themeFactory) {
    var ctrl = this;

    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {id: $routeParams.id}, "/ownsecurityroles/view").then(function () {
        defineButtons();
    });

    ctrl.save = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/ownsecurityroles/save").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.delete = function (event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {id: $routeParams.id}, "/ownsecurityroles/delete").then(function () {
                BackService.back();
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return $scope.data.id > 0 && !$scope.data.isDeprecated;
    }
    
}